import { render } from "./RelProdutosPorDataTable.vue?vue&type=template&id=5548c972&scoped=true"
import script from "./RelProdutosPorDataTable.vue?vue&type=script&lang=js"
export * from "./RelProdutosPorDataTable.vue?vue&type=script&lang=js"

import "./RelProdutosPorDataTable.vue?vue&type=style&index=0&id=5548c972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5548c972"]])

export default __exports__